<template>
  <div v-if="loadingStarted">
    <Loading></Loading>
  </div>
  <div v-else-if="loadingSuccessful">
    <SurveyContainer></SurveyContainer>
  </div>
  <div v-else-if="failedToLoad">
    <div class="centered-row">
      <ErrorPage>
        <div slot="header">{{notFoundHeader}}</div>
        <div slot="message">{{messageNotFound}}</div>
      </ErrorPage>
    </div>
  </div>
</template>

<script>
  import {
    GET_SURVEY_PREVIEW, LOADING_COMPLETED_FAILURE,
    LOADING_COMPLETED_SUCCESS,
    LOADING_STARTED,
    SET_SURVEY_PREVIEW
  } from "../../services/constants"
  import SurveyContainer from "./SurveyContainer"
  import ErrorPage from "../views/ErrorPage"

    export default {
      name: "SurveyPreview",

      components: {ErrorPage, SurveyContainer},

      created() {
        this.$store.commit(SET_SURVEY_PREVIEW, true)
        this.$store.dispatch(GET_SURVEY_PREVIEW, this.$route.params.study_id)
      },

      computed: {
        loadingStarted(){
          return this.$store.state.surveyModule.survey.loadingState === LOADING_STARTED
        },
        loadingSuccessful(){
          return this.$store.state.surveyModule.survey.loadingState === LOADING_COMPLETED_SUCCESS
        },
        failedToLoad() {
          return this.$store.state.surveyModule.survey.loadingState === LOADING_COMPLETED_FAILURE
        },
        notFoundHeader() {
          return 'ERROR'
        },
        messageNotFound() {
          return this.$store.state.surveyModule.survey.error.message
        },

      }

    }
</script>

<style scoped>

</style>
